import { ModulosEnumChoice } from '@/shared/constants/choices/choices.constants';
import { 
  Comentario,
  EstadoBitacoraEnum,
  EstadoMotivoEnum,
  IDataBitacoraRespById,
  Venta 
} from '@/shared/interfaces/erp/bitacora/bitacora.interface';
import { initializeSocket } from '@/shared/socket/socket.config';
import { useAuthStore } from '@/store/auth/auth.store';
import { toast, TypeOptions } from 'react-toastify';
import { Socket } from 'socket.io-client';
import { create } from 'zustand';

interface DiccionarioMotivo {
  isConnected: boolean
  setIsConnected: (isConnected: boolean) => void
  departamento: string //'OTRO'
  setDepartamento: (departamento: string) => void
  onConnect: () => void

  dataGetVentaById: Venta | null
  setDataGetVentaById: (dataGetVentaById: Venta | null) => void
  emitGetVentaById: (numero_referencia_venta: string, filtros?: any) => void

  dataGetComentariosMotivos: { motivo_id: string, comentarios: Comentario[] }
  setDataGetComentariosMotivos: (params?: { motivo_id: string, comentarios: Comentario[] }) => void

  emitGetComentariosMotivos: (params: { numero_referencia_venta: string, diccionario_motivo_id: string, motivo_id: string }) => void

  onComentariosMotivos: () => void
  emitFinalizarVenta: ({ numero_referencia_venta, estado_venta }: { numero_referencia_venta: string, estado_venta: EstadoBitacoraEnum }) => void
  emitEnviarComentario: (params: {
    numero_referencia_venta: string, diccionario_motivo_id: string, motivo_id: string,
    comentario_texto: string, username_create_venta: string,
    tipo: string
  }) => void
  onNuevoComentario: () => void

  onAlertaBitacora: () => void
  emitRegistrarUsuario: () => void

  emitActualizarMotivo: (params: { numero_referencia_venta: string, diccionario_motivo_id: string, motivo_id: string }) => void
  emitActualizarComentariosLeidos: (params: { numero_referencia_venta: string, diccionario_motivo_id: string, motivo_id: string, username: string }) => void

  onErrorBitacora: () => void
  onReconnect: () => void

  socketOff: () => void

  ///
  expanded: boolean | string
  setExpanded: (expanded: boolean) => void
  handleChange: ({ panel, numero_referencia_venta, diccionario_motivo_id, motivo_id }: { panel: string, numero_referencia_venta: string, diccionario_motivo_id: string, motivo_id: string }) => (_event: React.SyntheticEvent, isExpanded: boolean) => void

  selectedImage: File | null
  setSelectedImageBitacora: (selectedImage: File | null) => void
  imagePreview: string | null
  setImagePreview: (imagePreview: string | null) => void

  handleEnviarComentario: () => void

  open: boolean
  setOpen: (openRead: boolean) => void
  openRead: boolean
  setOpenRead: (open: boolean) => void

  handleCrearBitacora: () => void

  detalle: any | null
  setDetalle: (detalle: any | null) => void

  openCreaBitacora: boolean
  setOpenCreaBitacora: (openCreaBitacora: boolean) => void

  selectedMotivos: any[];
  setSelectedMotivos: (seletedMotivo: any[]) => void

  fase_venta?: ModulosEnumChoice;
  setFaseVenta: (faseVenta: ModulosEnumChoice) => void

  socket: Socket | null

  valueTab: number
  setValueTab: (valueTab: number) => void

  setCloseBitacora: () => void

  /* bitacoraLectura: boolean
  setBitacoraLectura: (bitacoraLectura: boolean) => void */

}

export const useDiccionarioMotivo = create<DiccionarioMotivo>((set, get) => ({
  /* bitacoraLectura: false,
  setBitacoraLectura(bitacoraLectura) {
    set({ bitacoraLectura })
  }, */
  setCloseBitacora() {
    set({ openRead: false })
    set({ valueTab: 1 })
    set({ open: false })
    set({ dataGetVentaById: null })
    set({ detalle: null })
    set({
      dataGetComentariosMotivos: {
        motivo_id: '',
        comentarios: []
      }
    })
    set({ selectedImage: null })
    set({ imagePreview: null })
    set({ selectedMotivos: [] })
  },

  valueTab: 1,
  setValueTab(valueTab) {
    set({ valueTab })
  },
  socket: null,
  isConnected: false,
  setIsConnected(isConnected) {
    set({ isConnected })
  },
  onConnect() {
    const user = useAuthStore.getState().user;

    const socket = initializeSocket({
      username: user?.username,
      rol: user?.rol,
      canal_venta: user?.canal_venta ?? 'PYL',
      departamento: user?.departamento,
      canales_venta_adicionales: JSON.stringify(user?.canales_venta_adicionales ?? [])
    })
    set({ socket })
  },
  emitFinalizarVenta(params) {

    if (!get().socket) return;
    get().socket?.emit('finalizarVenta', (params), (data: any) => {
      console.log('finalizarVenta:', data);
    })
  },
  emitActualizarComentariosLeidos(params) {

    get().socket!.emit('actualizarComentariosLeidos', (params), (data: any) => {
      console.log(data, 'actualizarComentariosLeidos');
    })

  },
  dataGetVentaById: null,
  setDataGetVentaById(dataGetVentaById) {
    set({ dataGetVentaById })
  },
  async emitGetVentaById(numero_referencia_venta,) {
    if (!get().socket) return;

    get().socket!.emit('getVentaById', ({
      numero_referencia_venta,
    }), (data: IDataBitacoraRespById) => {
      set({ dataGetVentaById: data.data })
    })
  },

  dataGetComentariosMotivos: { comentarios: [], motivo_id: '' },
  setDataGetComentariosMotivos(params = { comentarios: [], motivo_id: '' }) {
    set({ dataGetComentariosMotivos: params })
  },
  emitGetComentariosMotivos({ numero_referencia_venta, diccionario_motivo_id, motivo_id }) {
    if (!get().socket) return;

    get().socket?.emit('getComentariosMotivos', ({
      numero_referencia_venta,
      diccionario_motivo_id,
      motivo_id
    }))
  },
  onComentariosMotivos() {

    if (!get().socket) return;
    get().socket?.on('comentariosMotivos', (data: { motivo_id: string, comentarios: Comentario[] }) => {
      set({ dataGetComentariosMotivos: data })
    })
  },


  emitEnviarComentario(data) {
    if (!get().socket) return;
    const user = useAuthStore.getState().user;
    get().socket!.emit('enviarComentario', {
      ...data,
      departamento: user?.departamento,
      username: user?.username,
      rol: user?.rol,
    })

  },
  onNuevoComentario() {

    if (!get().socket) return;

    get().socket!.on('nuevoComentario', ({ comentario, motivo_id }: { comentario: Comentario, motivo_id: string }) => {

      if (get().dataGetComentariosMotivos.motivo_id === motivo_id) {
        const aux = [...get().dataGetComentariosMotivos.comentarios, comentario]
        set({ dataGetComentariosMotivos: { motivo_id: motivo_id, comentarios: aux } })
      }

      /* set((state) => {
        if (motivo_id == state.dataGetComentariosMotivos.motivo_id) {
          state.dataGetComentariosMotivos.comentarios.push(comentario)
          return { dataGetComentariosMotivos: state.dataGetComentariosMotivos }
        }
        return { dataGetComentariosMotivos: state.dataGetComentariosMotivos }
      }) */
    })
  },

  onAlertaBitacora() {
    if (!get().socket) return;

    console.log('handle onAlertaBitacora');

    get().socket?.on('alertaBitacora', (data: { mensaje: string, status: string, numero_referencia_venta?: string, }) => {

      console.log('nueva alerta');

      toast(data.mensaje, {
        type: 'info',
        autoClose: 5000,
        onClick: () => {
          set({ open: true })
          if (data.numero_referencia_venta) {
            get().emitGetVentaById(data.numero_referencia_venta)
          }
        }
      })
    })
  },

  emitRegistrarUsuario() {
    if (!get().socket) return;

    const user = useAuthStore.getState().user;

    get().socket?.emit('registrarUsuario', {
      username: user?.username,
      departamento: user?.departamento,
      nombre: user?.razon_social,
      rol: user?.rol
    }, (_data: any) => {

    })
  },

  emitActualizarMotivo(params) {
    if (!get().socket) return;

    const username = useAuthStore.getState().user?.username

    get().socket?.emit('actualizarMotivo', ({
      ...params,
      username,
      estado_motivo: EstadoMotivoEnum.RESUELTO,
    }), (data: any) => {
      if (data.code == 200) {
        get().emitGetVentaById(params.numero_referencia_venta)
        set({ expanded: false })
      }
    })
  },

  onErrorBitacora() {
    if (!get().socket) return;
    get().socket?.on('bitacoraError', (data: { message: string, status: TypeOptions }) => {
      toast(data.message, {
        type: data.status
      })
    })
  },
  onReconnect() {
    if (!get().socket) return;

    get().socket?.on('reconnect', () => {
      console.log('reconectando socket ...');
      get().onAlertaBitacora();
    })

  },

  socketOff() {
    get().socket?.off('getMotivosComentarios')
    get().socket?.off('bitacoraError')
    get().socket?.off('getNuevoComentario')
    get().socket?.off('alertaBitacora')
    get().socket?.off('contadorMotivos')
    get().socket?.off('contadorVentas')
    get().socket?.off('nuevoComentario')
    get().socket?.off('comentariosMotivos')
    get().socket?.off('reconnect')
  },

  ///
  openRead: false,
  setOpenRead(openRead) {
    set({ openRead })
  },
  expanded: false,
  setExpanded(expanded) {
    set({ expanded })
  },

  handleChange: ({ panel, numero_referencia_venta, diccionario_motivo_id, motivo_id }) => (_event, isExpanded) => {
    if (isExpanded && panel) {
      set({ selectedImage: null })
      const user = useAuthStore.getState().user;
      get().socket?.emit('joinRoom', ({ motivo_id: motivo_id, username: user?.username, rol: user?.rol })) //* TODO: converit en funcion 

      get().emitGetComentariosMotivos({
        numero_referencia_venta,
        diccionario_motivo_id: diccionario_motivo_id,
        motivo_id: motivo_id
      })

    }
    set({ expanded: isExpanded ? panel : false })
  },

  selectedImage: null,
  setSelectedImageBitacora(selectedImage) {
    set({ selectedImage })
  },
  imagePreview: null,
  setImagePreview(imagePreview) {
    set({ imagePreview })
  },
  handleEnviarComentario() {

  },
  open: false,
  setOpen(open) {
    set({ open })
  },
  handleCrearBitacora() {

  },
  openCreaBitacora: false,
  setOpenCreaBitacora(openCreaBitacora) {
    set({ openCreaBitacora })
  },
  detalle: null,
  setDetalle(detalle) {
    set({ detalle })
  },
  selectedMotivos: [],
  setSelectedMotivos(selectedMotivos) {
    set({ selectedMotivos })
  },
  fase_venta: undefined,
  setFaseVenta(fase) {
    set({ fase_venta: fase })
  },
  departamento: 'OTRO',
  setDepartamento(departamento) {
    set({ departamento })
  },

}));
